/* eslint-disable */
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */
export * from './header__instructions.js'
export * from './header_action__instructions.js'
export * from './header_action.js'
export * from './header_donate.js'
export * from './header_events__instructions.js'
export * from './header_events.js'
export * from './header_faq.js'
export * from './header_join__instructions.js'
export * from './header_join.js'
export * from './header_learn.js'
export * from './header_proposal.js'
export * from './home_action_c2a.js'
export * from './home_action_content.js'
export * from './home_action_title.js'
export * from './home_hero__instructions.js'
export * from './home_hero.js'
export * from './home_proposal_c2a.js'
export * from './home_proposal_content__instructions.js'
export * from './home_proposal_content.js'
export * from './home_proposal_title.js'
export * from './home_quotes_all.js'
export * from './home_quotes_bengio_text.js'
export * from './home_quotes_bengio_title.js'
export * from './home_quotes_asi_statement_text.js'
export * from './home_quotes_asi_statement_author.js'
export * from './home_quotes_asi_statement_title.js'
export * from './home_quotes_cais_text.js'
export * from './home_quotes_cais_author.js'
export * from './home_quotes_cais_title.js'
export * from './home_quotes_hawking_text.js'
export * from './home_quotes_hawking_title.js'
export * from './home_quotes_hinton_text.js'
export * from './home_quotes_hinton_title.js'
export * from './home_quotes_russell_text.js'
export * from './home_quotes_russell_title.js'
export * from './home_quotes_turing_text.js'
export * from './home_quotes_turing_title.js'
export * from './home_risks_c2a.js'
export * from './home_risks_content.js'
export * from './home_risks_title.js'
export * from './home_stats_alignment.js'
export * from './home_stats_citizens.js'
export * from './home_urgency_c2a.js'
export * from './home_urgency_content.js'
export * from './home_urgency_title.js'
export * from './home_xrisk_c2a.js'
export * from './home_xrisk_content.js'
export * from './home_xrisk_title.js'
export * from './simpletoc_heading.js'
export * from './footer_join.js'
export * from './footer_info.js'
export * from './footer_info_faq.js'
export * from './footer_info_proposal.js'
export * from './footer_info_learn.js'
export * from './footer_info_press.js'
export * from './footer_info_people.js'
export * from './footer_info_partnerships.js'
export * from './footer_info_privacy.js'
export * from './footer_info_legal.js'
export * from './footer_info_legal_foundation.js'
export * from './footer_info_legal_kvk.js'
export * from './footer_risks.js'
export * from './footer_risks_overview.js'
export * from './footer_risks_outcomes.js'
export * from './footer_risks_xrisk.js'
export * from './footer_risks_psychology.js'
export * from './footer_risks_takeover.js'
export * from './footer_risks_cybersecurity.js'
export * from './footer_risks_capabilities.js'
export * from './footer_risks_sota.js'
export * from './footer_risks_urgency.js'
export * from './footer_action.js'
export * from './footer_action_join.js'
export * from './footer_action_help.js'
export * from './footer_action_communities.js'
export * from './footer_action_donate.js'
export * from './footer_action_merchandise.js'
export * from './footer_action_events.js'
export * from './footer_action_vacancies.js'
export * from './footer_action_email.js'
export * from './footer_action_lobby.js'
export * from './footer_other.js'
export * from './footer_other_pages.js'
export * from './footer_other_rss.js'
export * from './footer_other_license.js'
export * from './footer_other_feedback.js'
export * from './footer_other_edit.js'
export * from './footer_other_l10n.js'
export * from './newsletter_heading.js'
export * from './newsletter_description.js'
export * from './newsletter_email_placeholder.js'
export * from './newsletter_button.js'
export * from './newsletter_success.js'
export * from './uk_email_mp_title.js'
export * from './uk_email_mp_description.js'
export * from './uk_email_mp_uk_only_notice.js'
export * from './learn_risks.js'
export * from './learn_xrisk.js'
export * from './learn_ai_takeover.js'
export * from './learn_quotes.js'
export * from './learn_feasibility.js'
export * from './learn_building_the_pause_button.js'
export * from './learn_faq.js'
export * from './learn_action.js'
export * from './footer_info_about.js'